// UserAgent Protection Utility
// Import this in any component that might encounter userAgent issues

let isProtected = false;

export const protectUserAgent = () => {
  if (isProtected || typeof window === 'undefined' || typeof navigator === 'undefined') {
    return;
  }

  try {
    // Store original userAgent
    const originalUserAgent = navigator.userAgent;
    
    // Check if userAgent is already protected
    const descriptor = Object.getOwnPropertyDescriptor(navigator, 'userAgent');
    if (descriptor && !descriptor.configurable) {
      isProtected = true;
      return;
    }

    // Protect userAgent from redefinition
    Object.defineProperty(navigator, 'userAgent', {
      get: function() {
        return originalUserAgent;
      },
      configurable: false,
      enumerable: true
    });

    // Intercept Object.defineProperty calls on userAgent
    const originalDefineProperty = Object.defineProperty;
    Object.defineProperty = function(obj, prop, descriptor) {
      if (obj === navigator && prop === 'userAgent') {
        console.warn('Prevented attempt to redefine navigator.userAgent');
        return obj;
      }
      return originalDefineProperty.apply(this, arguments);
    };

    isProtected = true;
    console.log('UserAgent protection activated');

  } catch (error) {
    console.warn('Could not protect userAgent:', error.message);
  }
};

export const handleUserAgentError = (error) => {
  if (error && error.message && error.message.includes('Cannot redefine property: userAgent')) {
    console.warn('UserAgent redefinition error caught and handled:', error.message);
    return true; // Error was handled
  }
  return false; // Error was not handled
};

// Auto-protect on import
protectUserAgent(); 